import * as z from "zod";

export const connectStripeIntegration = {
  name: "connectStripeIntegration" as const,
  input: z.object({ apiKey: z.string() }),
  output: z.object({ success: z.boolean() }),
};
